/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {MediaBoxInfo, MediaBoxInfoMeta} from 'react-weui';
import {renderMoney, TimeStream, getJsonFromUrl} from '../../utils';

import '../../styles/channel/ChannelLectureRecord.css';

import ChannelPersonCount from '../../images/channel-person-cuont.png'
import ChannelLectureProgress from '../../images/channel-lecture-progress.png'


class ChannelLectureRecord extends Component {
    initStarttime() {
        const {lecture, role} = this.props;
        let value = '';
        if (lecture.status === 'closed') {
            if (role.is_manager || lecture.audio_length < 5) {
                value = TimeStream(lecture.start_timestamp);
            } else {
                value = '时长' + lecture.audio_length + '分钟'
            }
        } else {
            if (lecture.start_timestamp * 1000 <= Date.parse(new Date())) {
                value = '正在进行';
            } else {
                if ((lecture.start_timestamp * 1000) - Date.parse(new Date()) >= 86400000) {
                    value = TimeStream(lecture.start_timestamp, '-D') + '天后'
                } else {
                    value = TimeStream(lecture.start_timestamp, '-H') + '小时后';
                }
            }
        }
        return value;
    }

    initMoney() {
        const {role, channel, lecture, granted, isRelay} = this.props;
        let value = '';

        if (granted && !role.is_manager) {
            return value;
        }

        if (role.is_liveroom_vip && lecture.lecture_type !== 'password_lecture') {
            if (!isRelay) {
                value = 'VIP免费';
            } else {
                if (channel.need_money && lecture.lecture_type === 'pay_lecture') {
                    value = granted ? '' : "￥" + renderMoney(lecture.money);
                }
            }
        } else if (channel.need_money) {
            if (lecture.lecture_type === 'open_lecture') {
                value = '试听';
            } else if (role.is_manager && lecture.lecture_type === 'pay_lecture') {
                value = lecture.limit_money ? "￥" + renderMoney(lecture.limit_money.money) : "￥" + renderMoney(lecture.money);
            } else if (!granted && lecture.lecture_type === 'pay_lecture') {
                value = lecture.limit_money ? "￥" + renderMoney(lecture.limit_money.money) : "￥" + renderMoney(lecture.money);
            }
        } else if (lecture.lecture_type === 'pay_lecture') {
            value = lecture.limit_money ? "￥" + renderMoney(lecture.limit_money.money) : "￥" + renderMoney(lecture.money)
        }
        return value;
    }

    renderSaleTags() {
        let moneyValue = this.initMoney();
        const {lecture} = this.props;
        if (lecture.lecture_type === 'password_lecture') {
            return (
                <div className="channel-lecture-types_item channel-lecture-types-password">
                    <p>加密</p>
                </div>
            )
        } else if (lecture.lecture_type === 'pay_lecture') {
            if (lecture.limit_money) {
                return (
                    <div className="channel-lecture-types_item channel-lecture-types-free">
                        <p>限时免费</p>
                    </div>
                )
            } else {
                return (
                    <div className="channel-lecture-types-money">
                        <p>{moneyValue}</p>
                    </div>
                )
            }
        }
    }

    renderLectureMode() {
        const {lecture} = this.props;
        if (lecture.lecture_type === 'password_lecture') {
            return (
                <span className="liveroom-lecture-tag">
                    <i className="icon iconfont icon-suo tag-mode-fontsize"></i>
                </span>
            )
        }
    }

    renderLectureTag() {
        const {lecture} = this.props;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-shipin1 tag-mode-fontsize"></i>
                    </span>
                    );
                case 'audio':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-erji tag-mode-fontsize"></i>
                    </span>
                    );
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-shipin1 tag-mode-fontsize"></i>
                    </span>
                    );
                case 'audio':
                    return (
                        <span className="liveroom-lecture-mode">
                        <i className="icon iconfont icon-erji tag-mode-fontsize"></i>
                    </span>
                    );
                default:
                    return true
            }
        }
    }

    renderFinish() {
        const {lecture} = this.props;
        if (lecture.finish === '' || !lecture.finish) {
            return '0%'
        } else {
            return lecture.finish + '%'
        }
    }

    render() {
        const {lecture, lectureFinish} = this.props;
        let timestampValue = this.initStarttime();
        let moneyValue = this.initMoney();
        const urlParams = getJsonFromUrl();
        const href = urlParams && urlParams.isPresent ? `/lecture/${lecture.id}?isPresent=true` : `/lecture/${lecture.id}`;
        
        return (
            <a href={href} className="channel-lecture-record"
               key={lecture.id}>
                <div className="weui-flex weui-padding lecture-item">
                    <div className="lecture-img background-image"
                         style={{backgroundImage: `url(${lecture.cover_url})`}}>
                        {this.renderLectureMode()}
                        {this.renderLectureTag()}
                    </div>
                    <div className="weui-flex__item padding-left flex_2">
                        <div className="lecture-title">
                            <div className="lecture-title-name">
                                {lecture.name}
                            </div>
                        </div>
                        <div className="channel-lecture-types">
                            {lectureFinish && (this.renderFinish() !== '0%' && this.renderFinish() !== '0.00%') && false &&
                            <div className="channel-lecture-bottom_finish">
                                <img src={ChannelLectureProgress} alt=""/>
                                <p>{lectureFinish ? this.renderFinish() : 'loading...'}</p>
                            </div>
                            }
                        </div>
                        <div className="channel-lecture-bottom">
                            <div className="channel-lecture-bottom_left">
                                <div className="channel-lecture-bottom_count" style={{marginRight: '20px'}}>
                                    <p style={{marginLeft: '0'}}>{timestampValue}</p>
                                </div>
                                <div className="channel-lecture-bottom_count">
                                    <img src={ChannelPersonCount} alt=""/>
                                    <p>{lecture.popular}</p>
                                </div>
                            </div>
                            <div className="channel-lecture-bottom_time">
                                <p> {moneyValue}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        )
    }
}

export default connect((state) => ({
    role: state.channel.role,
    channel: state.channel.channel,
    granted: state.channel.channel_access.granted,
    isRelay: state.channel.channel.is_relay,
    lectureFinish: state.channel.lectureFinish,
}))(ChannelLectureRecord)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelLectureRecord.js